<template>
  <div class="b-player">
    <div class="b-player-container">
      <div :key="rand">
        <video :id="id" :autoplay="autoplay" :controls="controls" :width="width" :height="autoHeight" :loop="loop" :muted="muted" :poster="poster" :preload="preload">
          <source v-for="(a, b) in types" :key="b" :src="url" :type="a.type">
          <object :data="url" :width="width" :height="height">
            <embed :src="url" :width="width" :height="height">
          </object>
          <span v-if="prompt != ''">{prompt}</span>
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bplayer',
  props: {
    id: { type: String, default: () => (`b-player-${Math.random().toString().substring(2)}`) },
    autoplay: { type: Boolean, default: () => true },
    controls: { type: Boolean, default: () => true },
    loop: { type: Boolean, default: () => false },
    muted: { type: Boolean, default: () => false },
    poster: { type: String, default: () => '' },
    preload: { type: String, default: () => 'auto' },
    width: { type: String, default: () => '100%' },
    height: { type: String, default: () => '0' },
    url: { type: String, default: () => '' },
    type: { type: String, default: () => 'video/mp4' },
    prompt: { type: String, default: () => '尊敬的用户, 您好! 您的浏览器不支持 HTML5 video 视频播放。' },
    playText: { type: String, default: () => '' },
  },
  data() {
    return {
      rand: 0,
      types: [
        { name: 'mp4', type: 'video/mp4' },
        { name: 'ogg', type: 'video/ogg' },
        { name: 'webm', type: 'video/webm' },
      ],
      autoHeight: '0',
    }
  },
  watch: {
    url() {
      this.create();
    }
  },
  created() {
    this.create()
  },
  mounted() {
    this.update();
    let timeout = null;
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    } else {
      timeout = setTimeout(() => {
        addEventListener('resize', () => this.update());
        clearTimeout(timeout);
        timeout = null;
      }, 100);
    }
  },
  destroyed() {
    this.cancel();
  },
  methods: {
    create() {
      this.rand = Math.random();
    },
    update() {
      const container = document.getElementById(this.id);
      if (container) this.autoHeight = (container.clientWidth / 1.25) + 'px';
    },
    cancel() {
      removeEventListener('resize', this.update);
    },
  },
}
</script>

<style scoped>
@import "index.css";
</style>